import styled from "styled-components";
import { Button, Flex, Typography } from "antd";
import { COLORS } from "../../../utils/colors";

const { Text } = Typography;

export const MarkDoneButton = styled(Button)`
  && {
    height: 28px;
    padding: 0 16px;
    border-radius: 8px;
    background: ${COLORS.surface};
    border: 1px solid ${COLORS.border};
    color: ${COLORS.textBody};
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    font-weight: 500;
    box-shadow: none;

    &:hover,
    &:focus {
      background: ${COLORS.surface} !important;
      color: ${COLORS.textBody} !important;
      border-color: ${COLORS.primary} !important;
      box-shadow: none !important;
    }
  }
`;

export const DoneControl = styled(Flex)`
  && {
    display: inline-flex;
    width: fit-content;
    height: 28px;
    border-radius: 8px;
    background: ${COLORS.entriesbg};
    overflow: hidden;
  }
`;

export const DoneLabel = styled(Flex)`
  && {
    height: 100%;
    padding: 0 10px 0 12px;
    color: ${COLORS.primary};
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    font-weight: 500;

    .anticon {
      font-size: 14px;
    }
  }
`;

export const MoreButton = styled(Button)`
  && {
    height: 28px;
    width: 28px;
    min-width: 28px;
    padding: 0;
    border: none;
    border-radius: 0;
    background: transparent;
    color: ${COLORS.primary};
    box-shadow: none;
    outline: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    .anticon {
      font-size: 15px;
    }
  }

  &&:hover,
  &&:focus,
  &&:focus-visible,
  &&:active,
  &&.ant-dropdown-open {
    background: transparent !important;
    color: ${COLORS.primary} !important;
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
  }
`;

export const ResetItem = styled(Flex)`
  && {
    padding: 2px 4px;
    max-width: 220px;
  }
`;

export const ResetTitle = styled(Text)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    font-weight: 600;
    color: ${COLORS.textBody};
    line-height: 18px;
  }
`;

export const ResetSubtitle = styled(Text)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 11px;
    color: ${COLORS.textMuted};
    line-height: 15px;
    white-space: normal;
  }
`;
